(() => {
  if (window.__pdlPredictiveLogicalProductsLoaded) return;
  window.__pdlPredictiveLogicalProductsLoaded = true;

  const CARD_SELECTOR = '.predictive-search-results__card--product[data-pdl-resource-product-id]';
  let scheduled = 0;

  const normalizeSku = (value) => String(value || '').trim().toLowerCase();

  const skuSet = (card) => new Set(
    String(card.dataset.pdlResourceSkus || '')
      .split(/\s+/)
      .map(normalizeSku)
      .filter(Boolean)
  );

  const sameLogicalProduct = (a, b) => {
    if (!a.skus.size || !b.skus.size || a.price !== b.price) return false;
    return [...a.skus].some((sku) => b.skus.has(sku));
  };

  const restore = (cards) => {
    cards.forEach((card) => {
      card.hidden = false;
      delete card.dataset.pdlPredictiveHidden;
      card.classList.remove('pdl-predictive-logical-card');
      card.querySelectorAll('.pdl-predictive-stores-badge').forEach((badge) => badge.remove());
    });
  };

  const buildGroups = (items) => {
    const parent = items.map((_, index) => index);
    const find = (index) => {
      while (parent[index] !== index) {
        parent[index] = parent[parent[index]];
        index = parent[index];
      }
      return index;
    };
    const union = (a, b) => {
      const rootA = find(a);
      const rootB = find(b);
      if (rootA !== rootB) parent[rootB] = rootA;
    };

    for (let a = 0; a < items.length; a += 1) {
      for (let b = a + 1; b < items.length; b += 1) {
        if (sameLogicalProduct(items[a], items[b])) union(a, b);
      }
    }

    const groups = new Map();
    items.forEach((item, index) => {
      const root = find(index);
      if (!groups.has(root)) groups.set(root, []);
      groups.get(root).push(item);
    });
    return [...groups.values()];
  };

  const badgeMarkup = (label, ariaLabel) => {
    const badge = document.createElement('span');
    badge.className = 'pdl-predictive-stores-badge';
    badge.setAttribute('role', 'status');
    badge.setAttribute('aria-label', ariaLabel);
    badge.innerHTML = `<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M12 2a7 7 0 0 0-7 7c0 5.1 7 13 7 13s7-7.9 7-13a7 7 0 0 0-7-7Zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5Z"/></svg><span></span>`;
    badge.querySelector('span').textContent = label;
    return badge;
  };

  const apply = () => {
    document.querySelectorAll('#predictive-search-products').forEach((root) => {
      const cards = [...root.querySelectorAll(CARD_SELECTOR)];
      restore(cards);

      const items = cards.map((card, index) => ({
        card,
        index,
        productId: String(card.dataset.pdlResourceProductId || ''),
        price: Number(card.dataset.pdlResourcePrice || 0),
        inventory: Number(card.dataset.pdlResourceInventory || 0),
        skus: skuSet(card)
      }));

      buildGroups(items).forEach((group) => {
        const productIds = new Set(group.map((item) => item.productId).filter(Boolean));
        if (group.length < 2 || productIds.size < 2) return;

        const canonical = group.reduce((best, item) => {
          if (!best || item.inventory > best.inventory) return item;
          return best;
        }, null);

        canonical.card.classList.add('pdl-predictive-logical-card');
        canonical.card.appendChild(
          badgeMarkup(
            root.dataset.pdlTwoStoresLabel || '2 lojas',
            root.dataset.pdlTwoStoresAria || 'Disponível em São Leopoldo e Porto Alegre'
          )
        );

        group.forEach((item) => {
          if (item === canonical) return;
          item.card.hidden = true;
          item.card.dataset.pdlPredictiveHidden = 'true';
        });
      });
    });
  };

  const schedule = () => {
    window.clearTimeout(scheduled);
    scheduled = window.setTimeout(apply, 30);
  };

  const start = () => {
    schedule();
    new MutationObserver((records) => {
      const hasResultCards = records.some((record) => [...record.addedNodes].some((node) => {
        if (!(node instanceof Element)) return false;
        return node.matches?.(CARD_SELECTOR) || Boolean(node.querySelector?.(CARD_SELECTOR));
      }));
      if (hasResultCards) schedule();
    }).observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', schedule);
})();
